﻿<template>
    <section class="mb-card">
        <div class="mb-card-body">
            <h3 class="mb-card-title">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M3 21h18M5 21V7l7-4 7 4v14M9 9h1M9 13h1M9 17h1M14 9h1M14 13h1M14 17h1" />
                </svg>
                Agency details
            </h3>
            <p class="mb-card-intro">
                To amend your details, update the form below and click Send changes to email them to us, or contact us at
                <a :href="'mailto:' + get_email_address()">{{get_email_address()}}</a>.
            </p>

            <dl class="mb-dl">
                <div>
                    <dt>Agency</dt>
                    <dd>{{account_information.name || '—'}}</dd>
                </div>
                <div>
                    <dt>Agent code</dt>
                    <dd>{{account_information.code || '—'}}</dd>
                </div>
                <div>
                    <dt>Payment method</dt>
                    <dd>{{Payment_Methods() || '—'}}</dd>
                </div>
            </dl>

            <div class="mb-form-grid is-two">
                <div class="mb-field is-full">
                    <label for="address_1">Address</label>
                    <input type="text" name="address_1" id="address_1" spellcheck="false" autocomplete="address-line1" v-model="account_information.address_1" class="mb-input" />
                </div>
                <div class="mb-field is-full">
                    <label for="address_2" class="sr-only">Address line 2</label>
                    <input type="text" name="address_2" id="address_2" spellcheck="false" autocomplete="address-line2" v-model="account_information.address_2" class="mb-input" placeholder="Address line 2 (optional)" />
                </div>
                <div class="mb-field">
                    <label for="post_code">Postcode</label>
                    <input type="text" name="post_code" id="post_code" spellcheck="false" autocomplete="postal-code" v-model="account_information.post_code" class="mb-input" />
                </div>
                <div class="mb-field">
                    <label for="telephone">Phone number</label>
                    <input type="tel" name="telephone" id="telephone" spellcheck="false" autocomplete="tel" v-model="account_information.telephone" class="mb-input" />
                </div>
                <div class="mb-field is-full">
                    <label for="agency_email">Email</label>
                    <input type="email" name="email" id="agency_email" spellcheck="false" autocomplete="email" v-model="account_information.email" class="mb-input" />
                </div>
            </div>

            <div class="mb-form-actions">
                <button type="button" class="button" @click="Email_Agency()">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />
                    </svg>
                    Send changes
                </button>
                <span class="mb-hint">Opens an email with your changes, ready to send.</span>
            </div>
        </div>
    </section>
</template>
<script lang="ts" src="./account_information.ts"></script>
